<template>
  <article v-if="isExistsItem() === true" class="iv2-banner">
    <div class="container-fluid banners">
      <div class="row clearfix">
        <div class="column full">
          <div class="spacer height-60"></div>
        </div>
      </div>

      <div class="row clearfix d-none d-md-flex">
        <div
          v-for="item in banner.items"
          :key="item.id"
          :class="listLayout(banner.setting.type)"
        >
          <a
            rel="noopener"
            :href="item.link_href"
            :target="setTargetAttr(item.is_external)"
            @click="clickEventTrigger(item.analytics_event_name)"
          >
            <picture>
              <source
                type="image/webp"
                :srcset="
                  item.image + $store.state.publicLang.general.image_webp
                "
              />
              <img class="m-0" :src="item.image" :alt="item.alternative_text" />
            </picture>
          </a>
        </div>
      </div>

      <div class="row clearfix d-md-none mb-3">
        <div class="column full">
          <div class="iv2-banner__slider">
            <span
              v-if="banner.items.length > 1"
              @click="sliderPrev"
              class="iv2-banner__slider-prev-btn"
            >
              <i class="fas fa-chevron-left"></i>
            </span>
            <div class="iv2-banner__slider-content">
              <div
                v-for="(item, index) in banner.items"
                :key="item.id"
                class="iv2-banner__slider-content-box"
              >
                <transition :name="transitionName">
                  <a
                    v-if="visibleContent == index"
                    rel="noopener"
                    :href="item.link_href"
                    :target="setTargetAttr(item.is_external)"
                    @click="clickEventTrigger(item.analytics_event_name)"
                    class="d-block"
                  >
                    <picture>
                      <source
                        type="image/webp"
                        :srcset="
                          item.image +
                          $store.state.publicLang.general.image_webp
                        "
                      />
                      <img
                        class="iv2-banner__slider-content-img m-0"
                        :src="item.image"
                        :alt="item.alternative_text"
                      />
                    </picture>
                  </a>
                </transition>
              </div>
            </div>
            <span
              v-if="banner.items.length > 1"
              @click="sliderNext"
              class="iv2-banner__slider-next-btn"
            >
              <i class="fas fa-chevron-right"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="row clearfix">
        <div class="column full">
          <div class="spacer height-40"></div>
          <hr class="theme__footer-hr m-0 p-0" />
          <div class="spacer height-40"></div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    banner: Object,
  },

  data() {
    return {
      visibleContent: 0,
      transitionName: "next",
      query: "",
      lang: "",
    };
  },

  mounted() {
    if (this.$route.query.mode == "preview") {
      this.query = "?mode=preview";
    }
    if (this.$route.query.hl) {
      this.lang = "?hl=" + this.$route.query.hl;
    }

    if (this.banner.items.length > 1) {
      setInterval(() => {
        this.sliderNext();
      }, 6000);
    }
  },

  methods: {
    // スライダーを戻す処理
    sliderPrev() {
      this.transitionName = "prev";
      setTimeout(() => {
        if (this.visibleContent === 0) {
          this.visibleContent = this.banner.items.length - 1;
        } else {
          this.visibleContent--;
        }
      }, 50);
    },

    // スライダーを進める処理
    sliderNext() {
      this.transitionName = "next";
      setTimeout(() => {
        if (this.visibleContent === this.banner.items.length - 1) {
          this.visibleContent = 0;
        } else {
          this.visibleContent++;
        }
      }, 50);
    },

    listLayout(type) {
      let col = "col-md-4 col-xs-12 mb-3";
      switch (type) {
        case "468x60":
          col = "col-md-6 col-xs-12 mb-3";
          break;

        case "980x120":
          col = "col-xs-12 mb-3";
          break;
      }
      return col;
    },

    setTargetAttr(flag) {
      return flag === 1 ? "_blank" : "_self";
    },

    isExistsItem() {
      return this.banner.items.length > 0 ? true : false;
    },

    clickEventTrigger(event) {
      return this.$gtag != undefined &&
        event != undefined &&
        event != "" &&
        event != null
        ? this.$gtag.event("click", {
            event_category: "Banner",
            event_label: event,
            value: 1,
          })
        : false;
    },
  },
};
</script>

<style lang="scss">
.iv2-banner__slider {
  width: 80%;
  position: relative;
  margin: 0 auto;
  z-index: 1;

  &-prev-btn,
  &-next-btn {
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    width: 30px;
    padding: 0 10px;
    cursor: pointer;
  }

  &-prev-btn {
    left: -35px;
  }

  &-next-btn {
    right: -35px;
  }

  &-content {
    transition: all 0.2s;
    height: 150px;

    &-box {
      left: 0;
      position: absolute;
      text-align: center;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      overflow: hidden;
    }

    &-img {
      width: 100%;
      max-height: 150px;
    }
  }
}
</style>
